function ResponseUI({
  question,
  quiz,
  response,
  handleAnswerQuestion,
  hasOverlay,
  tabIndexNum,
  selectedResponse
}) {
  const { response: title, correct } = response
  // const callAnalytics = (text) => {
  //   window.appEventData.push({
  //     event: "UI Item Clicked",
  //     linkInfo: {
  //       category: "interactive",
  //       // itemPosition: ,
  //       text,
  //     },
  //   });
  // };
  
  const callAnalytics = (question, quiz, response) => {
    // console.log(quiz);
    // console.log("title " + quiz.title);
    //console.log("response" + response.response);
    window.appEventData.push({
      event: 'UI Item Clicked',
      linkInfo: {
        category: 'Quiz Response',
        subcategory: 'Response',
        regions: quiz.title,
        text: response.response,
        itemPosition: 'Quiz' + quiz.id,
      },
    })
  }

  return (
    <button
      className={`ResponseUI ${hasOverlay ? 'disabled' : ''} ${selectedResponse && selectedResponse.id===response.id?'selected':''}`}
      disabled={hasOverlay}
      onClick={() => {
        handleAnswerQuestion(response)
        callAnalytics(question, quiz, response)
      }}
      aria-label={title}
      tabIndex={tabIndexNum}
      aria-hidden={hasOverlay}
    >
      <div className={`responseUIButton ${hasOverlay ? 'disabled' : ''}`}>
        <div className="answer">{title}</div>
        {selectedResponse && selectedResponse.id===response.id && response.correct && hasOverlay && (
          <span className="answerIcon mck-checkmark-icon"></span>
        )}
        {selectedResponse && selectedResponse.id===response.id && !response.correct && hasOverlay && (
          <span className="answerIcon mck-close-thin-icon"></span>
        )}
      </div>
    </button>
  )
}

export default function ResponsesListUI({
  question,
  quiz,
  responses,
  handleAnswerQuestion,
  hasOverlay,
  tabIndexNum,
  selectedResponse
}) {
  return (
    <div className="ResponsesListUI">
      {responses.map((response, index) => (
        <ResponseUI
          question={question}
          quiz={quiz}
          key={response.id}
          response={response}
          handleAnswerQuestion={handleAnswerQuestion}
          hasOverlay={hasOverlay}
          tabIndexNum={tabIndexNum}
          selectedResponse={selectedResponse}
        />
      ))}
    </div>
  )
}
